module.exports = __webpack_public_path__ + "img/IMG-20200223-WA0030.82f8459c.jpg";